<div class="quick-filters-container" *ngIf="!isMobile">
  <ng-container [ngTemplateOutlet]="leftSideTemplate"></ng-container>
  <div class="d-flex align-items-center">
    <app-button-rectangle
      *ngIf="showAddButton"
      [text]="T.common.add | translate"
      [icon]="'add'"
      (clicked)="onAddBtnClick()"
      [app-tooltip]="{
        position: ['top'],
        message: T.common.add_item | translate: { item: T.common.item.one | translate },
      }"
    ></app-button-rectangle>
    <div class="divider-line" *ngIf="showAddButton"></div>
    <app-list-search-input-fixed
      *ngIf="showSearch"
      [background]="'var(--wt-neutral-extra-light)'"
      [placeholder]="searchPlaceholder"
      [value]="searchText"
      (inputChanged)="onListSearch($event)"
    ></app-list-search-input-fixed>
  </div>
  <ng-container *ngIf="showSuggestedFilters && !hideFilters">
    <div class="divider-line hide-divider"></div>
    <div class="suggested-filters-section">
      <app-wt-button
        *ngIf="showFiltersButton"
        ngDropdown
        #favFiltersDropdown="ngDropdown"
        [templateRef]="favoriteFilters"
        [templateOutletContext]="{ dropdownRef: favFiltersDropdown }"
        [active]="!!favouriteMatchingFilter"
      >
        <div class="btn-container">
          <span class="material-symbols-outlined">bookmark</span>
          <span>
            {{ favouriteMatchingFilter ? favouriteMatchingFilter.title : (T.common.saved_filters | translate) }}
          </span>
        </div>
      </app-wt-button>
    </div>
  </ng-container>
  <ng-container *ngIf="showQuickFiltersForFilterSelectors.length || customSelectOptions.length || hideFilters">
    <div class="divider-line filters-container-left"></div>
  </ng-container>

  @if (hideFilters && listObjectsTitle && listObjectsTitle.length) {
    <div class="quick-filters-section">
      {{ T.common.go_to_list_to_filter | translate: { items: listObjectsTitle } }}&nbsp;
      <app-button-transparent
        [text]="listObjectsTitle + ' ' + translatedList"
        [routerLink]="linkToDetails | url"
      ></app-button-transparent>
    </div>
  }

  <div class="quick-filters-section">
    <ng-container *ngFor="let filterSelector of showQuickFiltersForFilterSelectors">
      <app-select
        *ngIf="filterSelector.filterType !== filterTypes.Date"
        ngDropdown
        #quickFilterDropdown="ngDropdown"
        [closeUponSelection]="false"
        [templateRef]="quickFilterContent"
        [value]="getSelectedValues(filterSelector)"
        [label]="filterSelector.filterTypeText"
        [templateOutletContext]="{ filterSelector: filterSelector, dropdownRef: quickFilterDropdown }"
        [counter]="selectedFiltersCountForFilterType(filterSelector)"
        [isActive]="hasSelectedFiltersForFilterType(filterSelector)"
        [isFocused]="quickFilterDropdown.visible"
        (dropdownToggled)="onQuickFilterDropdownToggled($event)"
      >
      </app-select>
      <app-select
        *ngIf="filterSelector.filterType === filterTypes.Date"
        ngDropdown
        #quickDateFilterDropdown="ngDropdown"
        [closeUponSelection]="true"
        [templateRef]="quickDateFilterContent"
        [value]="getDateSelectValue(filterSelector)"
        [label]="filterSelector.filterTypeText"
        [customSelectSpacer]="getDateSelectValue(filterSelector)"
        [templateOutletContext]="{ filterSelector: filterSelector, dropdownRef: quickDateFilterDropdown }"
        [isActive]="hasSelectedFiltersForFilterType(filterSelector)"
        [isFocused]="quickDateFilterDropdown.visible"
        (dropdownToggled)="onQuickFilterDropdownToggled($event)"
      >
      </app-select>
    </ng-container>

    <ng-container *ngFor="let customSelect of customSelectOptions">
      <app-select *ngIf="!isMobile"
        ngDropdown
        #customSelectDropdown="ngDropdown"
        [closeUponSelection]="true"
        [templateRef]="customSelectContent"
        [value]="getCustomSelectDisplayValue(customSelect)"
        [label]="customSelect.label"
        [templateOutletContext]="{ customSelect: customSelect, dropdownRef: customSelectDropdown }"
        [isActive]="isCustomSelectActive(customSelect)"
        [isFocused]="customSelectDropdown.visible"
        (dropdownToggled)="onCustomSelectDropdownToggled($event, customSelect)"
      >
      </app-select>
      <ion-select *ngIf="isMobile"
        [label]="customSelect.label"
        [multiple]="customSelect.multiSelect"
        [value]="getCustomSelectValue(customSelect)"
        (ionChange)="onIonSelectChange($event, customSelect)"
        [interface]="customSelect.multiSelect ? 'alert' : 'action-sheet'"
        [okText]="customSelect.multiSelect ? (T.common.apply | translate) : undefined"
        [cancelText]="customSelect.multiSelect ? (T.common.cancel | translate) : undefined">
        <ion-select-option *ngFor="let option of customSelect.options"
          [value]="option.value">
          {{option.label}}
        </ion-select-option>
      </ion-select>
    </ng-container>
  </div>
  <div *ngIf="(showFiltersButton || showSettingsButton) && !hideFilters" class="divider-line hide-divider"></div>
  <div class="filter-actions-section">
    <app-button-transparent
      *ngIf="appliedFilters.length && showFiltersButton && !hideFilters"
      class="clear-all-btn"
      [text]="T.common.clear_all | translate"
      [icon]="'close'"
      [size]="'small'"
      (click)="onResetFilters()"
    >
    </app-button-transparent>
    <app-wt-button
      *ngIf="showFiltersButton && !hideFilters"
      class="open-filters-button ms-2"
      [active]="appliedFilters.length"
      [app-tooltip]="{ position: ['top'], message: savedFilterTooltip }"
      (clicked)="openSideFilters()"
    >
      <div class="d-flex align-items-center">
        <span class="material-symbols-outlined" style="font-size: 16px">filter_list</span>
        <span class="ms-1">{{ T.defaultLocalizations.filter.many | translate }}</span>
        <div class="applied-filters-count" *ngIf="appliedFilters.length">{{ appliedFilters.length }}</div>
      </div>
    </app-wt-button>
    <app-button-icon-square
      *ngIf="showSettingsButton"
      icon="settings"
      buttonTheme="white"
      [app-tooltip]="{ position: ['top'], message: editDisplayTooltip }"
      (clicked)="onSettingsBtnClick()"
      class="mr-8"
    ></app-button-icon-square>
    <ng-container [ngTemplateOutlet]="rightSideTemplate"></ng-container>
  </div>
  <div class="empty-filters-message-container" *ngIf="showEmptyFiltersMessage && !appliedFilters.length">
    <i class="material-symbols-outlined">info</i>
    <span class="empty-message">{{ T.common.empty_filters_message | translate }} </span>
  </div>
</div>

<!-- Mobile Quick Filters -->
<div class="mobile-quick-filters-container" *ngIf="isMobile">
  <div class="first-row">
    <app-button-rectangle
      *ngIf="showAddButton"
      class="me-2"
      [text]="T.common.add | translate"
      [icon]="'add'"
      (clicked)="onAddBtnClick()"
    ></app-button-rectangle>
    <div class="divider-line" *ngIf="showAddButton"></div>
    <app-list-search-input-fixed
      *ngIf="showSearch"
      class="w-100"
      [background]="'var(--wt-neutral-extra-light)'"
      [placeholder]="searchPlaceholder"
      [value]="searchText"
      (inputChanged)="onListSearch($event)"
    ></app-list-search-input-fixed>
    <div class="filter-actions-section">
      <app-wt-button
        *ngIf="showFiltersButton && !hideFilters"
        class="open-filters-button ms-2"
        [active]="appliedFilters.length"
        (clicked)="openSideFilters()"
      >
        <div class="d-flex align-items-center">
          <span class="material-symbols-outlined" style="font-size: 16px">filter_list</span>
          <span class="ms-1">{{ T.defaultLocalizations.filter.many | translate }}</span>
          <div class="applied-filters-count" *ngIf="appliedFilters.length">{{ appliedFilters.length }}</div>
        </div>
      </app-wt-button>
      <app-button-icon-square
        *ngIf="showSettingsButton"
        icon="settings"
        buttonTheme="white"
        (clicked)="onSettingsBtnClick()"
        class="mr-8"
      ></app-button-icon-square>
    </div>
  </div>
  <div class="second-row">
    <ng-container [ngTemplateOutlet]="leftSideTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="rightSideTemplate"></ng-container>
    <div *ngIf="showQuickFiltersOnMobile" class="quick-filters-section">
      <ng-container *ngFor="let filterSelector of showQuickFiltersForFilterSelectors">
        <div class="mobile-select-wrapper" *ngIf="filterSelector.filterType !== filterTypes.Date">
          <ion-select
            [label]="filterSelector.filterTypeText"
            [multiple]="true"
            [value]="getSelectedFilterIds(filterSelector)"
            (ionChange)="onMobileFilterSelectChange($event, filterSelector)"
            interface="alert"
            [okText]="T.common.apply | translate"
            [cancelText]="T.common.cancel | translate"
            [class.has-value]="hasSelectedFiltersForFilterType(filterSelector)">
            <ion-select-option *ngFor="let filter of getAllowedFiltersForFilterType(filterSelector.filterType)"
              [value]="filter.id.toString()">
              {{filter.filterText}}
            </ion-select-option>
          </ion-select>

          <button
            *ngIf="hasSelectedFiltersForFilterType(filterSelector)"
            class="clear-filter-btn"
            (click)="clearAllFiltersForFilterType(filterSelector); $event.stopPropagation()">
            <span class="material-symbols-outlined">cancel</span>
          </button>
        </div>

        <div class="mobile-select-wrapper" *ngIf="filterSelector.filterType === filterTypes.Date">
          <ion-select
            [label]="filterSelector.filterTypeText"
            [value]="getDateSelectValue(filterSelector)"
            (ionChange)="openMobileDateFilterSelect(filterSelector)"
            interface="alert"
            [okText]="T.common.ok | translate"
            [cancelText]="T.common.cancel | translate"
            [class.has-value]="hasSelectedFiltersForFilterType(filterSelector)">
            <ion-select-option value="none">{{ T.common.none | translate }}</ion-select-option>
            <ion-select-option *ngFor="let option of filterSelector.dateRangeOptions"
              [value]="option">
              {{ sanitizeFilterDateOption(option) }}
            </ion-select-option>
            <ion-select-option value="custom">{{ T.common.date_range | translate }}</ion-select-option>
          </ion-select>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #favoriteFilters let-dropdownRef="dropdownRef">
  <div class="favorite-filters-container">
    <div class="favorite-filters-body">
      <ng-container *ngIf="favoriteFiltersForObjectTypes.length">
        <div class="favorite-filter-option" *ngFor="let favFilter of favoriteFiltersForObjectTypes">
          <app-radio-button
            [text]="favFilter.title"
            [checked]="isFavoriteFilterSelected(favFilter)"
            (checkedChanged)="selectFavoriteFilter(favFilter)"
          ></app-radio-button>
          <div class="filter-actions">
            <span
              class="material-symbols-outlined edit-btn"
              (click)="onEditFavoriteFilter(favFilter); dropdownRef.onEscape()"
              >edit</span
            >
            <span
              class="material-symbols-outlined delete-btn"
              (click)="onDeleteFavoriteFilter(favFilter); dropdownRef.onEscape()"
              >delete</span
            >
          </div>
        </div>
      </ng-container>
      <div class="favorite-filter-option" *ngIf="!favoriteFiltersForObjectTypes.length">
        <span class="no-filters-text">{{ T.common.no_saved_filters | translate }}</span>
      </div>
    </div>
    <div class="favorite-filters-footer">
      <app-button-rectangle
        (clicked)="onFavoriteFiltersApply(); dropdownRef.onEscape()"
        [buttonTheme]="'white'"
        [disabled]="!favoriteFiltersForObjectTypes?.length"
        [text]="T.common.apply | translate"
      >
      </app-button-rectangle>
    </div>
  </div>
</ng-template>
<ng-template #quickFilterContent let-filterSelector="filterSelector" let-dropdownRef="dropdownRef">
  <div class="filter-container">
    <div class="filter-body custom-scrollbar">
      <app-filters-list-entries
        [entries]="getAllowedFiltersForFilterType(filterSelector.filterType)"
        [selectedEntries]="getAppliedFiltersByType(filterSelector)"
        [useCheckbox]="true"
        (click)="$event.stopPropagation(); $event.stopImmediatePropagation()"
        (entrySelected)="onFilterSelected($event, filterSelector)"
      ></app-filters-list-entries>
    </div>
    <div class="exclude-filters-container">
      <app-filters-exclude-selected
        [checkState]="excludeState(filterSelector)"
        [disabled]="!localSelectedFilters.length"
        (excluded)="onExclude($event, filterSelector)"
      >
      </app-filters-exclude-selected>
    </div>
    <div class="filter-footer">
      <app-button-transparent
        style="margin-right: auto"
        [text]="T.common.clear_all | translate"
        [size]="'small'"
        (clicked)="clearAllFiltersForFilterType(filterSelector); dropdownRef.onEscape()"
      ></app-button-transparent>
      <app-button-rectangle
        (clicked)="onApplyLocalFilters(); dropdownRef.onEscape()"
        [text]="T.common.apply | translate"
        [buttonTheme]="'white'"
      >
      </app-button-rectangle>
    </div>
  </div>
</ng-template>
<ng-template #quickDateFilterContent let-filterSelector="filterSelector" let-dropdownRef="dropdownRef">
  <div class="dates-filter-container">
    <div class="filter-body">
      <div class="date-filter-options-container">
        <div
          class="date-option"
          [ngClass]="{ selected: isNoneDateFilterSelected(filterSelector) }"
          (click)="removeDateFilter(filterSelector)"
        >
          {{ T.common.none | translate }}
        </div>
        <div
          class="date-option"
          *ngFor="let relativeOption of filterSelector.dateRangeOptions"
          (click)="onRelativeDateSelected(filterSelector, relativeOption)"
          [ngClass]="{ selected: isDateFilterSelected(filterSelector, relativeOption) }"
        >
          {{ sanitizeFilterDateOption(relativeOption) }}
        </div>
        <div
          class="date-option"
          [ngClass]="{ selected: isFixedDateRangeSelected(filterSelector) }"
          ngRangeDatepicker
          [startDate]="rangeFromDate(filterSelector)"
          [endDate]="rangeToDate(filterSelector)"
          [timePicker]="showTimePicker(filterSelector)"
          (datesChanged)="onDateRangeChanged($event, filterSelector)"
        >
          {{ T.common.date_range | translate }}
        </div>
        <div
          *ngIf="isFixedDateRangeSelected(filterSelector)"
          class="range-date-boxes"
          ngRangeDatepicker
          [startDate]="rangeFromDate(filterSelector)"
          [endDate]="rangeToDate(filterSelector)"
          [timePicker]="showTimePicker(filterSelector)"
          (datesChanged)="onDateRangeChanged($event, filterSelector)"
        >
          <div class="date-box">
            {{ getRangeDateStartValue(filterSelector) }}
          </div>
          <div class="date-box">
            {{ getRangeDateEndValue(filterSelector) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customSelectContent let-customSelect="customSelect" let-dropdownRef="dropdownRef">
  <div class="filter-container" [ngClass]="{ 'single-select-container': !customSelect.multiSelect }">
    <div class="filter-body custom-scrollbar">
      <ng-container *ngIf="customSelect.multiSelect">
        <div
          class="custom-select-option"
          *ngFor="let option of customSelect.options"
          [ngClass]="{ 'option-selected': isCustomSelectOptionSelected(customSelect, option) }"
          (click)="
            $event.stopPropagation();
            $event.stopImmediatePropagation();
            onCustomSelectOptionToggle(customSelect, option)
          "
        >
          <span class="option-label">{{ option.label }}</span>
          <app-checkbox
            [isChecked]="isCustomSelectOptionSelected(customSelect, option)"
            (checked)="onCustomSelectOptionToggle(customSelect, option)"
          >
          </app-checkbox>
        </div>
      </ng-container>

      <ng-container *ngIf="!customSelect.multiSelect">
        <div
          class="custom-select-option single-select"
          *ngFor="let option of customSelect.options"
          [ngClass]="{ 'option-selected': isCustomSelectOptionSelected(customSelect, option) }"
          (click)="
            $event.stopPropagation();
            $event.stopImmediatePropagation();
            onCustomSelectSingleOption(customSelect, option)
          "
        >
          <span class="option-label">{{ option.label }}</span>
        </div>
      </ng-container>
    </div>

    <div *ngIf="customSelect.multiSelect" class="filter-footer">
      <app-button-transparent
        style="margin-right: auto"
        [text]="T.common.clear_all | translate"
        [size]="'small'"
        (clicked)="clearCustomSelectOptions(customSelect); dropdownRef.onEscape()"
      >
      </app-button-transparent>
      <app-button-rectangle
        (clicked)="applyCustomSelectOptions(customSelect); dropdownRef.onEscape()"
        [text]="T.common.apply | translate"
        [buttonTheme]="'white'"
      >
      </app-button-rectangle>
    </div>
  </div>
</ng-template>

<ng-template #leftSideTemplate>
  <ng-content select="[left-side]"></ng-content>
</ng-template>

<ng-template #rightSideTemplate>
  <ng-content select="[right-side]"></ng-content>
</ng-template>
